import React, { useEffect, useState } from 'react';
import { InputGroup } from 'module-tsl-ui-elements';
import { getFromContext } from '../../../AlertFiltersContext';

export const FilterInputKeywords = () => {
  const { state, dispatch } = getFromContext();
  const [keyword, setKeyword] = useState('');

  const [keywordFacet] = state.facets.filter(({ queryStringId }) => queryStringId.indexOf('keywords') !== -1);

  useEffect(() => {
    if (keywordFacet) {
      return setKeyword(decodeURIComponent(keywordFacet.queryAs));
    }

    setKeyword('');
  }, [state.facets]);

  const onChange = ({ target: { value } }) => {
    setKeyword(value);
  };

  const onBlur = ({ target: { value } }) => {
    const facet = {
      name: value,
      queryStringId: `keywords=${encodeURIComponent(value)}`,
      queryAs: encodeURIComponent(value),
    };

    if (value === '' && keywordFacet) {
      return dispatch({
        type: 'remove',
        facet: keywordFacet,
      });
    }

    if (value !== '') {
      dispatch({
        type: keywordFacet ? 'update' : 'add',
        facet,
        key: 'keywords',
      });
    }
  };

  return (
    <InputGroup
      self={{ groupId: 'keywords' }}
      label={{ text: 'Search words' }}
      input={{
        onChange,
        onBlur,
        placeholder: 'Keywords',
        name: 'keywords',
        value: keyword,
      }}
    />
  );
};
